var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "soli-round" },
        [
          _c(
            "v-container",
            [
              _c(
                "v-card-title",
                { staticClass: "soli-grey" },
                [
                  _vm._v("Pay Rates"),
                  _vm.missingRates
                    ? _c("v-icon", { attrs: { right: "", color: "error" } }, [
                        _vm._v("error_outline"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showHelp = true
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v("help"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-subtitle",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "soli-round soli-blue-text",
                      attrs: {
                        "x-small": "",
                        outlined: "",
                        disabled:
                          !_vm.user.hasPermissions.includes("Work") &&
                          !_vm.user.hasRoles.includes("Staff"),
                      },
                      on: {
                        click: function ($event) {
                          ;[
                            (_vm.showForm = true),
                            (_vm.form.time_clock_rate = _vm.getDefaultType()),
                            (_vm.form.role_name = _vm.getDefaultRole()),
                          ]
                        },
                      },
                    },
                    [_vm._v("New Pay Rate")]
                  ),
                  _vm._v(" "),
                  _vm.payRates.length !== _vm.currentRates.length
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "soli-round soli-blue-text",
                          attrs: { "x-small": "", outlined: "" },
                          on: {
                            click: function ($event) {
                              _vm.showPayHistory = !_vm.showPayHistory
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.showPayHistory
                                ? "View Current Rates"
                                : "View Rate History"
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "cursor-pointer table-nowrap",
                attrs: {
                  headers: _vm.rateHeaders,
                  items: _vm.showPayHistory ? _vm.payRates : _vm.currentRates,
                  "hide-default-footer": "",
                  "mobile-breakpoint": "0",
                  "no-data-text": "No pay rates available",
                },
                on: {
                  "click:row": function ($event) {
                    return _vm.editPayRate($event)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.amount`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s("$" + item.amount + "/hour") +
                              "\n                "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.status`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-chip",
                            {
                              staticClass: "white--text",
                              class:
                                item.status == "Archived"
                                  ? "soli-grey"
                                  : item.status == "Scheduled"
                                  ? "soli-status-blue"
                                  : item.status == "Active"
                                  ? "soli-status-green"
                                  : "soli-status-red",
                              attrs: { pill: "", small: "" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.status)
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _vm.showForm
                ? _c("SoliForm", {
                    ref: "form",
                    attrs: {
                      title: `${_vm.form.id ? "Edit" : "Add"} Pay Rate`,
                      textSubtitle: _vm.disabled
                        ? "This rate has been applied to payroll or archived and cannot be edited. Please create a new pay rate."
                        : null,
                      text: "Save",
                      icon: "save",
                      mobileScroll: "",
                      saveChanges: _vm.editRateForm,
                      persistent: "",
                      disabled: !!_vm.disabled,
                    },
                    on: {
                      reset: function ($event) {
                        return _vm.reset()
                      },
                      "hook:mounted": function ($event) {
                        return _vm.getApiGroupEvents()
                      },
                      submit: function ($event) {
                        return _vm.submit()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex flex-col gap-4 mb-6" },
                                [
                                  _vm.requiresRateType
                                    ? _c("v-select", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          label: "Rate Type",
                                          items: [
                                            { text: "Teaching", value: false },
                                            { text: "Time Clock", value: true },
                                          ],
                                          outlined: "",
                                          dense: "",
                                          "prepend-inner-icon": "assignment",
                                          "hide-details": "auto",
                                          rules: [
                                            (v) =>
                                              v !== null ||
                                              "Rate type is required",
                                          ],
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.form.role_name =
                                              $event &&
                                              _vm.roleOptions.length > 1
                                                ? null
                                                : _vm.getDefaultRole()
                                          },
                                        },
                                        model: {
                                          value: _vm.form.time_clock_rate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "time_clock_rate",
                                              $$v
                                            )
                                          },
                                          expression: "form.time_clock_rate",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.time_clock_rate &&
                                  _vm.roleOptions.length > 1
                                    ? _c("v-select", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          label: "Rate Role",
                                          items: _vm.roleOptions,
                                          outlined: "",
                                          dense: "",
                                          "prepend-inner-icon": "engineering",
                                          "hide-details": "auto",
                                          rules: _vm.rules.select,
                                        },
                                        model: {
                                          value: _vm.form.role_name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "role_name", $$v)
                                          },
                                          expression: "form.role_name",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("StaffPayRate", {
                                    attrs: {
                                      label: "Amount per hour",
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.form.amount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "amount", $$v)
                                      },
                                      expression: "form.amount",
                                    },
                                  }),
                                  _vm._v(" "),
                                  !_vm.form.time_clock_rate
                                    ? _c("v-select", {
                                        attrs: {
                                          label: "Event",
                                          outlined: "",
                                          dense: "",
                                          items: _vm.rateOptions,
                                          "item-text": "title",
                                          "item-value": "id",
                                          "prepend-inner-icon": "event",
                                          rules: _vm.rules.select,
                                          "hide-details": "auto",
                                        },
                                        model: {
                                          value: _vm.form.group_event_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "group_event_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.group_event_id",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    staticClass: "soli-round",
                                    attrs: {
                                      items: ["W2", "1099"],
                                      outlined: "",
                                      "prepend-inner-icon": "gavel",
                                      dense: "",
                                      label: "Contract Type",
                                      rules: _vm.rules.select,
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.form.contract_type,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "contract_type", $$v)
                                      },
                                      expression: "form.contract_type",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("SoliDate", {
                                    attrs: {
                                      label: "Effective Date",
                                      error: _vm.errors.starts_at,
                                      rules: _vm.rules.input,
                                      min: _vm.minStartDate,
                                      noLimit: "",
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.form.starts_at,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "starts_at", $$v)
                                      },
                                      expression: "form.starts_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "cancelBtn",
                          fn: function (attrs) {
                            return [
                              !_vm.editRateForm && _vm.form.id
                                ? _c(
                                    "SoliBtn",
                                    _vm._b(
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          text: "Delete",
                                          icon: "delete",
                                          color: "soli-status-red",
                                          disabled: _vm.disabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deletePayRate(
                                              _vm.form.id
                                            )
                                          },
                                        },
                                      },
                                      "SoliBtn",
                                      attrs,
                                      false
                                    )
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2937182104
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showHelp
        ? _c("SoliResponsiveDialog", {
            attrs: { title: "About Pay Rates" },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showHelp = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-card-text", { staticClass: "pt-0" }, [
                        _vm._v(
                          "\n                A staff member or teacher can have multiple pay rates based\n                on their roles and type of work. Time clock rates will be\n                used for any non-teaching hours, while teacher rates will be\n                applied to lessons. A pay rate is required for each role.\n                "
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v(
                          "Pay rates can be scheduled to take effect at a\n                future date. If a rate is scheduled, it will automatically\n                become active on the specified date. Pay rates can also be\n                set retroactively, so long as a prior pay rate hasn't been\n                used to process payroll. Any pay rate that has been used to\n                process payroll is not able to be edited or removed.\n            "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4083339895
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }